import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  DEBTOR_LIST_ERROR,
  DEBTOR_LIST_LOADING,
  DEBTOR_LIST_RESET,
  DEBTOR_LIST_PAGINATION,
  DEBTOR_LIST_SUCCESS,
  DEBTOR_LIST_ORDER,
  DEBTOR_LIST_PAGE
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  pagination: [],
  order: {
    field: 'name', 
    direction: 'asc'
  },
  filter: {
    name: '',
    nip: '',
    regon: '',
    address: ''
  },
  currentPage: 1
};

function error(error) {
  return {type: DEBTOR_LIST_ERROR, error};
}

function loading(loading) {
  return {type: DEBTOR_LIST_LOADING, loading};
}

function success(items) {
  return {type: DEBTOR_LIST_SUCCESS, items};
}

function pagination(items) {
  return { type: DEBTOR_LIST_PAGINATION, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  pagination: state => state.pagination,
  order: state => state.order,
  filter: state => state.filter,
  currentPage: state => state.currentPage
};

const actions = {
    getItems({ commit, state }, page = '/debtors') {
      commit(loading(true));
      commit(error(null));
      return http.fetch(page + '?' + http.buildQueryParams(state.currentPage, state.order, state.filter))
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
          commit(pagination(data['hydra:pagination']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    },
    order: function(context, column) {
      context.commit(DEBTOR_LIST_ORDER, column);
      context.dispatch('getItems');
    },
    changePage: function(context, page) {
      context.commit(DEBTOR_LIST_PAGE, page);
      context.dispatch('getItems');
    }
};

const mutations = {
    [DEBTOR_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [DEBTOR_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [DEBTOR_LIST_PAGINATION] (state, payload) {
      state.pagination = payload.items;
    },
    [DEBTOR_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [DEBTOR_LIST_RESET] (state) {
      state.items = [];
      state.currentPage = 1;
    },
    [DEBTOR_LIST_ORDER] (state, column) {
      if (state.order.field == column && state.order.direction !== 'desc') {
        state.order.direction = 'desc';
      }
      else if (state.order.field == column && state.order.direction == 'desc') {
        state.order.field = '';
      }
      else {
        state.order.direction = 'asc';
        state.order.field = column;
      }
    },
    [DEBTOR_LIST_PAGE] (state, page) {
       state.currentPage = page;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/debtor/list.js